// src/Services/fetchHomes.js
import { ApiRequestInterceptor } from "./apiRequest";
import { HOMES } from "../constants/endpoints/endpoints";

export const fetchHomes = async () => {
  const method = "GET";
  const response = await ApiRequestInterceptor(HOMES.homes, method);
  const { code, data } = response;

  if (code === 200) {
    return { code, data };
  } else {
    throw new Error("Error al obtener datos de Home");
  }
};
